import { UNSAFE_FilterToken as FilterToken } from "@procore/core-react";
import React from "react";
import type { BoardsFilterTypes, BoardsFilterOptionTypes } from "../filter-panel";

const boardsFilterPills: Array<{
   name: BoardsFilterOptionTypes;
   filterType: "multiselect" | "boolean";
   label: string;
}> = [
   { name: "selectedProjects", filterType: "multiselect", label: "Projects" },
   { name: "jobTitles", filterType: "multiselect", label: "Job Titles" },
   { name: "resourceStatuses", filterType: "multiselect", label: "Resource Statuses" },
   { name: "hideLabor", filterType: "boolean", label: "Hide Labor" },
   { name: "hideEquipment", filterType: "boolean", label: "Hide Equipment" },
   { name: "hideAssignments", filterType: "boolean", label: "Hide Assignments" },
   { name: "hideRequests", filterType: "boolean", label: "Hide Requests" },
   { name: "hideEmptyProjects", filterType: "boolean", label: "Hide Empty Projects" },
   { name: "projectTags", filterType: "multiselect", label: "Tags" },
   { name: "projectRoles", filterType: "multiselect", label: "Project Roles" },
];

const initialBoardsFilter: BoardsFilterTypes = {
   selectedProjects: [],
   jobTitles: [],
   resourceStatuses: [],
   hideLabor: false,
   hideEquipment: false,
   hideAssignments: false,
   hideRequests: false,
   hideEmptyProjects: false,
   projectTags: [],
   projectRoles: [],
   projectCustomFields: [],
};

export const BoardsFilterPills = (props: {
   boardsFilter: BoardsFilterTypes;
   onFilterUpdate: <K extends keyof BoardsFilterTypes>(key: K, value: BoardsFilterTypes[K]) => void;
}) => {
   const { boardsFilter, onFilterUpdate } = props;

   const onTokenRemoveClick = (name: BoardsFilterOptionTypes) => {
      onFilterUpdate(name, initialBoardsFilter[name]);
   };

   const onCustomFieldRemove = (customFieldId: string) => {
      const updated = (boardsFilter.projectCustomFields ?? []).filter(
         (f) => f.custom_field_id !== customFieldId,
      );
      onFilterUpdate("projectCustomFields", updated);
   };

   return (
      <div className="filterPillsWrapper">
         {boardsFilterPills.map((pill) => {
            const currentFilter: any = boardsFilter[pill.name];
            if (!currentFilter) return null;

            const isActive = Array.isArray(currentFilter)
               ? currentFilter.length > 0
               : currentFilter === true;

            if (!isActive) return null;

            let label = "";

            switch (pill.filterType) {
               case "multiselect":
                  if (Array.isArray(currentFilter) && currentFilter.length) {
                     label = `${pill.label} (${currentFilter.length})`;
                  }
                  break;
               case "boolean":
                  if (currentFilter) {
                     label = pill.label;
                  }
                  break;
               default:
                  return null;
            }

            if (!label) return null;

            return (
               <FilterToken key={pill.name} style={{ padding: "0 12px" }}>
                  <FilterToken.Label style={{ fontWeight: "600" }}>{label}</FilterToken.Label>
                  <FilterToken.Remove
                     onClick={() => onTokenRemoveClick(pill.name)}
                     style={{ marginLeft: "6px", padding: "0 4px" }}
                  />
               </FilterToken>
            );
         })}
         {boardsFilter.projectCustomFields?.map((cfFilter) => (
            <FilterToken key={cfFilter.custom_field_id} style={{ padding: "0 12px" }}>
               <FilterToken.Label style={{ fontWeight: "600" }}>{cfFilter.name}</FilterToken.Label>
               <FilterToken.Remove
                  onClick={() => onCustomFieldRemove(cfFilter.custom_field_id!)}
                  style={{ marginLeft: "6px", padding: "0 4px" }}
               />
            </FilterToken>
         ))}
      </div>
   );
};
